import styled from 'styled-components';
import { BrandLogo } from '../Header/Header.styles';

export const BrandLogoAnimated = styled(BrandLogo)`
  height: 100%;
  width: 100%;
`;
